import { yaNative } from '@weberus/ui/utils/ya-native';

import config from '@/conf';

/**
 * 앱/웹 환경에 따라 홈으로 이동한다.
 *
 * @param isNoHistory - 웹 환경에서 history를 남기지 않고 이동 필요한 경우
 */
export const goToHome = (isNoHistory?: boolean) => {
  if (yaNative.isEnabled) {
    yaNative.deepLink({ link: `${config.service.home.deepLink}` });
  } else if (isNoHistory) {
    window.location.replace(config.service.home.origin!);
  }
  window.location.assign(config.service.home.origin!);
};
